<div>
  <div class="ch-breadcrumbs">
    <va-breadcrumbs [breadcrumbs]="breadcrumbs$ | async" class="breadcrumbs"></va-breadcrumbs>
  </div>
  @if ({
    pkg: storePackage$ | async,
    getItNowFlag: getItNowflag$ | async,
    usesExternalUrl: usesExternalUrl,
    salesperson: salesperson$ | async
    }; as pageData) {
    <div
      class="package-details"
      >
      @if (pageData.pkg; as pkg) {
        <div class="stencil-fade">
          @if (getItNowflag$ | async) {
            <store-package-details-v2
              [pkg]="pkg"
              (getItNow)="addPackageToCart(pkg)"
              [actionLabel]="labelBuyItNow"
              [hideTags]="true"
              [appPrice]="appPrice$ | async"
            ></store-package-details-v2>
          } @else {
            @if (pageData.usesExternalUrl) {
              <store-package-details-v2
                [pkg]="pkg"
                (getItNow)="openDialog(pkg)"
                [actionLabel]="labelExternalURL"
                [hideTags]="true"
                [appPrice]="appPrice$ | async"
              ></store-package-details-v2>
            } @else {
              @if (pageData.salesperson; as salesperson) {
                <store-package-details-v2
                  [pkg]="pkg"
                  [showActionButton]="!!salesperson"
                  (getItNow)="openDialog(pkg, salesperson)"
                  [actionLabel]="labelContact"
                  [hideTags]="true"
                ></store-package-details-v2>
              } @else {
                <store-package-details-v2
                  [pkg]="pkg"
                  [showActionButton]="false"
                  [hideTags]="true"
                ></store-package-details-v2>
              }
            }
          }
          @if (pageData.salesperson; as salesperson) {
            @if ((getItNowflag$ | async) || pageData.usesExternalUrl) {
              <store-salesperson-details
                [packagePricing]="pkg.pricing"
                [salesperson]="salesperson"
                (getItNow)="openDialog(pkg, salesperson)"
                [actionLabel]="labelExternalURL"
              ></store-salesperson-details>
            } @else {
              <store-salesperson-details
                [packagePricing]="pkg.pricing"
                [salesperson]="salesperson"
                (getItNow)="openDialog(pkg, salesperson)"
                [actionLabel]="labelContact"
              ></store-salesperson-details>
            }
          }
        </div>
      } @else {
        <store-details-stencil></store-details-stencil>
      }
    </div>
  }
</div>
